import Container from '../Container';
import { ProcessLayoutProps } from '@/types/other';
import { Navbar } from 'react-bootstrap';
import Image from 'next/image';
import Link from 'next/link';
import Logo from '@/public/logo.svg';

const ProcessLayoutV2 = ({ children }: ProcessLayoutProps) => {
  return (
    <div>
      <Navbar expand="lg" className="border-bottom p-0">
        <Container>
          <Navbar.Brand className="spiritoryLogo" as={Link} href="/">
            <Image src={Logo} alt="Spiritory Logo" />
          </Navbar.Brand>
        </Container>
      </Navbar>

      <Container fluid>{children}</Container>
    </div>
  );
};

export default ProcessLayoutV2;
